import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track22CBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track22CBlue" transform="translate(2077.000000, 1193.000000)" className="track">
		<g id="line" transform="translate(0.000000, -0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M282.012816,161.310324 L286.975446,130.558475 C291.783923,100.761867 282.877355,70.3874723 262.739511,47.9057794 L220.5,0.75 L220.5,0.75"/>

			<TrackArrow transform="translate(282.000000, 159.000000) rotate(-83.000000) translate(-282.000000, -159.000000) "
									points="286 167 278 159 286 151"/>
			<path
				d="M0,228.15625 C9.94380556,238.673934 19.8876111,249.191618 29.8314167,259.709302 C39.9302751,270.390988 56.3066294,272.120252 68.413753,263.783412 C81.0705642,255.068063 87.0041617,239.42328 83.3102715,224.506599 L76.9650364,198.883248 C75.8388592,194.335516 78.612578,189.735903 83.1603106,188.609726 C86.2814214,187.83683 89.5712429,188.894952 91.6565712,191.342421 L95.5771514,195.943855 C106.309514,208.540016 125.214676,210.06684 137.829347,199.35624 L206.784695,140.809076 C214.78375,134.017406 226.774002,134.996185 233.565672,142.99524 C236.25511,146.162791 237.831994,150.124669 238.054775,154.273986 L238.997528,171.832883 C239.891094,188.475641 245.399545,204.541174 254.906145,218.230748 C258.146466,222.896834 264.555875,224.052645 269.221962,220.812324 C271.51666,219.218792 273.064465,216.760418 273.509551,214.00236 L279.819239,174.903222 L279.819239,174.903222"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track22CBlue')}
			coords="270.000000, 92.250000"
			text="22C"
			textCoordsX="7.16259766"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

Track22CBlue.propTypes = trackPropTypes;

export default Track22CBlue;
